/**
 * Shared author → display-label mapping. Extracted from TeamLogStream.tsx so
 * BuildCompleteCard.tsx can show the same attribution without a circular
 * import (TeamLogStream renders BuildCompleteCard, not the other way round).
 */
export function authorLabelFor(author: string): string {
  if (author === "advisor") return "Advisor";
  if (author === "claude-code") return "Dev";
  if (author === "travis") return "Travis";
  if (author.startsWith("dev-")) return author; // dev-1, dev-2, etc.
  return author;
}
